import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CwtCheckoutDeliveryAddressComponent } from './cwt-checkout-delivery-address.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KnBrCartPageOptionsComponentModule } from 'src/app/kn-br-draft-order/kn-br-draft-order-list/kn-br-cart-page-options/kn-br-cart-page-options.module';
import { CwtCartOrderSummaryComponent } from 'src/app/kn-br-draft-order/kn-br-draft-order-list/kn-br-cart-page-options/cwt-cart-order-summary/cwt-cart-order-summary.component';
import { FormErrorsModule } from '@spartacus/storefront';
import { CwtCheckoutScheduleDeliveryComponent } from '../cwt-checkout-schedule-delivery/cwt-checkout-schedule-delivery.component';
import { CwtCheckoutPaymentComponent } from '../cwt-checkout-payment/cwt-checkout-payment.component';
import { CwtCheckoutInstructionsComponent } from '../cwt-checkout-instructions/cwt-checkout-instructions.component';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        I18nModule,
        FormErrorsModule,
        NgSelectModule,
        KnBrCartPageOptionsComponentModule,
        FormsModule, CommonModule, FormErrorsModule, I18nModule, NgSelectModule, ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtCheckoutOrderSummary: {
                    component: CwtCartOrderSummaryComponent,
                },
                CwtCheckoutPickup: {
                    component: CwtCheckoutDeliveryAddressComponent,
                },
                CwtCheckoutDeliveryMode: {
                    component: CwtCheckoutDeliveryAddressComponent,
                },
                CwtCheckoutScheduleDelivery: {
                    component: CwtCheckoutScheduleDeliveryComponent,
                }, CwtCheckoutStorePickup: {
                    component: CwtCheckoutScheduleDeliveryComponent,
                },
                CwtCheckoutDeliveryInstruction: {
                    component: CwtCheckoutInstructionsComponent,
                },
                CwtCheckoutPaymentDetails: {
                    component: CwtCheckoutPaymentComponent,
                },
            },
        } as CmsConfig),
        CwtCheckoutDeliveryAddressComponent, CwtCheckoutPaymentComponent,
    ],
    providers: [DatePipe]
})
export class CwtCheckoutDeliveryAddressModule { }
